export default "__VITE_ASSET__CAZZEVe$__"